// export const parentAPI = "https://beta.tenvicsports.com/app/tenvic/";
export const parentAPI = "http://localhost/app/tenvic/";

// Tenvic Login
export const TenvicLogin = parentAPI + "login";

// Tenvic Logout
export const TenvicLogout = parentAPI + "logout";

// Tenvic ChangePassword
export const TenvicChangePassword = parentAPI + "changepassword";

// Tenvic Forgot Password
export const ForgotPasswordLink = parentAPI + "forgotpassword";

// Tenvic Reset Password
export const ResetPassword = parentAPI + "resetpassword";

// Validate Password Token 
export const ValidatePasswordToken = parentAPI + "validatetoken";

// Menu List based on roles
export const GetUserMenus = parentAPI + "usermenu";

// Roles list
export const RolesList = parentAPI + "listrole";

// get specific role
export const GetRole = parentAPI + "getrole";

// create role
export const AddRole = parentAPI + "createrole";

// update role
export const UpdateRole = parentAPI + "updaterole";

// delete role
export const DeleteRole = parentAPI + "deleterole";

// Permissions list
export const PermissionsList = parentAPI + "listpermission";

// get specific permission
export const GetPermission = parentAPI + "getpermission";

// create permission
export const AddPermission = parentAPI + "createpermission";

// update Permission
export const UpdatePermission = parentAPI + "updatepermission";

// delete permission
export const DeletePermission = parentAPI + "deletepermission";

// Role Permissions list
export const RolePermissionsList = parentAPI + "listrolepermission";

// get specific role permission
export const GetRolePermission = parentAPI + "getrolepermission";

// create role permission
export const AddRolePermission = parentAPI + "createrolepermission";

// update role Permission
export const UpdateRolePermission = parentAPI + "updaterolepermission";

// delete role permission
export const DeleteRolePermission = parentAPI + "deleterolepermission";

// menu list
export const MenuList = parentAPI + "listmenu";

// get specific menu
export const GetMenu = parentAPI + "getmenu";

// create menu
export const AddMenu = parentAPI + "createmenu";

// update menu
export const UpdateMenu = parentAPI + "updatemenu";

// delete menu
export const DeleteMenu = parentAPI + "deletemenu";

// menu role list
export const MenuRoleList = parentAPI + "listmenurole";

// get specific menu role
export const GetMenuRole = parentAPI + "getmenurole";

// create menu role
export const AddMenuRole = parentAPI + "createmenurole";

// update menu role
export const UpdateMenuRole = parentAPI + "updatemenurole";

// delete menu role
export const DeleteMenuRole = parentAPI + "deletemenurole";

// submenu list
export const SubMenuList = parentAPI + "listsubmenu";

// get submenu 
export const GetSubMenu = parentAPI + "getsubmenu";

// get submenu by menu id
export const GetSubMenuByMenu = parentAPI + "listsubmenubymenu";

// create sub menu
export const AddSubMenu = parentAPI + "createsubmenu";

// update submenu
export const UpdateSubMenu = parentAPI + "updatesubmenu";

// delete menu role
export const DeleteSubMenu = parentAPI + "deletesubmenu";

// list user rbac
export const ListUserRBAC = parentAPI + "listuserrbac";

// get user rbac
export const GetUserRBAC = parentAPI + "getuserrbac";

// create user rbac
export const CreateUserRBAC = parentAPI + "createuserrbac";

// update user rbac
export const UpdateUserRBAC = parentAPI + "updateuserrbac";

// delete user rbac
export const DeleteUserRBAC = parentAPI + "deleteuserrbac";

// list users
export const ListUsers = parentAPI + "listuser";

// get user
export const GetUser = parentAPI + "getuser";

// create user
export const CreateUser = parentAPI + "register";

// update user
export const UpdateUser = parentAPI + "updateuser";

// delete user
export const DeleteUser = parentAPI + "deleteuser";

// client list
export const ClientList = parentAPI + "listclient";

// get specific client
export const GetClient = parentAPI + "getclient";

// create client
export const AddClient = parentAPI + "createclient";

// update client
export const UpdateClient = parentAPI + "updateclient";

// delete client
export const DeleteClient = parentAPI + "deleteclient";